import React from 'react';
import './styles/Projects.scss';
import projectsData from '../config/projects';

const Projects = () => {
    const featuredProjects = projectsData.slice(0, 4);

    return (
        <section id="projects" className="projects">
            <h2 className="projects__title">Featured Projects</h2>

            <div className="projects-container">
                {featuredProjects.map((project, index) => (
                    <div
                        className="project-card"
                        key={project.id || index}
                        style={{ '--card-border-color': project.borderColor }}
                    >
                        <div className="project-image-column">
                            <img src={project.image} alt={`Screenshot of ${project.title}`}/>
                        </div>
                        <div className="project-details-column">
                            <h3>{project.title}</h3>
                            <p>{project.description}</p>
                            <div className="project-tech-stack"
                        style={{ '--card-color': project.techStackColor }}>
                                <h4>Tools & Technologies:</h4>
                                {project.techStack.map((tech, techIndex) => (
                                    <span key={techIndex}>{tech}</span>
                                ))}
                            </div>
                            <div className="project-links" style={{ '--button-color': project.borderColor }}>
                                {project.githubLink && (
                                    <a
                                        href={project.githubLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="github-btn"
                                    >
                                    GitHub Repo
                                    </a>
                                )}
                                {project.demoLink && (
                                    <a
                                        href={project.demoLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="demo-btn"
                                    >
                                        Live Demo
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Projects;